import { useCompetencia } from '@/global/components/Selects/SelectCompetencia'
import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useTrocaAutomaticaHorarioOutletContext } from '@/pages/TrocaAutomaticaHorario.context'
import { tabelaHorarios } from '@/service/api'
import CalendarioTabelasHorario from '@/templates/Cadastro/Funcionarios/organismos/forms/TabelaHorario/Calendario/CalendarioTabelasHorario'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'

export default function ViewHorarios() {
    const { id } = useParams<{ id: string }>()
    const { data: routeData } = useTrocaAutomaticaHorarioOutletContext()
    const item = routeData?.find(it => it.id === Number(id))

    const [competencia, setCompetencia] = useCompetencia()
    const competenciaDayjs = dayjs(competencia, 'YYYY-MM')
    const { data = [] } = tabelaHorarios.funcionario.useFetch({
        queryParams: {
            funcionarioId: item?.funcionarioId || -1,
            dataInicial: competenciaDayjs
                .startOf('month')
                .subtract(2, 'weeks')
                .format('YYYY-MM-DD'),
            dataFinal: competenciaDayjs
                .endOf('month')
                .add(2, 'weeks')
                .format('YYYY-MM-DD'),
        },
        enabled: !!item,
    })

    if (!item) return null

    return (
        <Dialog.Root open={hasPermission(['read', 'TabelaDeHorários'])}>
            <Dialog.Title action="Tabelas de horário">
                {item.Funcionario?.nome}
            </Dialog.Title>
            <Dialog.Content>
                <CalendarioTabelasHorario
                    value={competencia}
                    tabelas={data}
                    onChange={setCompetencia}
                    editable={false}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
